import React from 'react';

// Compact "Customer / Ship To / Contact" card strip shown consistently across
// every OrderXV4 step so the current selection (or its absence) is always
// visible, not just on the step where it's being edited. Renders blank/"Not
// selected" placeholders until formValues actually has a value — never
// fabricates a label from a raw ID before the matching details have loaded.
const CustomerShipToContactCards = ({ formValues, className = '' }) => {
  const cards = [
    {
      key: 'customer',
      label: 'Customer',
      value: formValues?.customer_search || formValues?.customer,
      sub: formValues?.customer_details?.billingAddress,
    },
    {
      key: 'ship_to',
      label: 'Ship To',
      value: formValues?.ship_to_search || formValues?.ship_to,
      sub: formValues?.ship_to_details?.address,
    },
    {
      key: 'contact',
      label: 'Contact',
      value: formValues?.contact_details?.label
        || formValues?.contact_details?.contactName
        || formValues?.contact,
    },
  ];

  return (
    <div className={`d-flex flex-wrap gap-2 ${className}`}>
      {cards.map((c) => (
        <div
          key={c.key}
          className="border rounded p-2 flex-grow-1"
          style={{ minWidth: 160 }}
        >
          <div className="text-muted text-uppercase" style={{ fontSize: 11, letterSpacing: 0.3 }}>
            {c.label}
          </div>
          {c.value ? (
            <>
              <div className="fw-semibold small text-truncate" title={c.value}>{c.value}</div>
              {c.sub && <div className="text-muted small text-truncate" title={c.sub}>{c.sub}</div>}
            </>
          ) : (
            <div className="text-muted small fst-italic">Not selected</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CustomerShipToContactCards;
